<mat-form-field class="form-field" [appearance]="appearance">
    
    <mat-label>
        {{label}}
    </mat-label>

    <ng-container *ngIf="multiple; else issueStatusSingleSelection">

        <mat-select [formControl]="formControl" multiple>
            <mat-option *ngFor="let s of status" [value]="s.stateid">
                {{s.statename}}
            </mat-option>
        </mat-select>

    </ng-container>

    <ng-template #issueStatusSingleSelection>

        <mat-select [formControl]="formControl">
            <mat-option *ngFor="let s of status" [value]="s.stateid">
                {{s.statename}}
            </mat-option>
        </mat-select>

    </ng-template>
    
</mat-form-field>
